class TipoPago{
    constructor(
        Nombre,
        ListaBancos
    ){
        this.Nombre=Nombre;
        this.ListaBancos=ListaBancos;
    }
}

export default TipoPago;